export default Object.freeze({
  Unset: -1,
  NoExiste: 0,
  Preliminar: 1,
  PendienteIntervencion: 2,
  PendienteAprobacion: 3,
  Aprobado: 4,
  Denegado: 5,
  Pagado: 6,
  EnviadoFinanzas: 7,
  EnProcesoPago: 8,
  PendienteLiberacion: 9,
  PendienteInformacion: 10,
  PendienteRevision: 12,
  PendienteIntervencionObjetada: 13,
  EnProcesoDeAjuste: 14,
  Sometida: 15,
  EnProcesoIntervencion: 16,
  EnProcesoIntervencionObjetada: 17,
  EnviadoFinanzasParcial: 18,
  PagadoParcial: 19,
  PendienteAprobacionTPFA: 20,
  DevueltoTPFA: 21,
  PreAprobado: 22,
  Cancelada: 23,
});
